
import TitleService from 'title-service';
import './ProfileFormNameEditField.scss';
export default function ProfileFormNameEditField(props: {
    name: string,
    onChange: (val: string) => void
}) {
    return (
        <fieldset className="sc-dVhcbM XuGVs " display="inline">
            <legend className="sc-fAjcbJ eIfxFy">editProfile</legend>
            <span style={{
                position: 'relative', display: 'block'
            }}>
                <input aria-label={TitleService("Profile Name")}
                    data-testid="profile-name-input"
                    display="inline" id="editProfile" name="profileName"
                    placeholder={TitleService("Profile Name")} type="text"
                    onChange={(evt) => {
                        props.onChange(evt.currentTarget.value);
                    }}
                    className="sc-jAaTju fmqfIm sc-eqIVtm csbJFj text-color--primary body-copy form-input-text"
                    value={props.name || ''}
                />
                <div className="metadata text-color--secondary padding--top-2 padding--left-1">
                </div>
            </span>
        </fieldset>
    );
}